import { useEffect, useState } from "react";
import CuDropdown from "../../common_component/component/CuDropdown";
import CuSpinner from "../../common_component/component/CuSpinner";
import InputField from "../../common_component/component/InputField";
import "../css/CustomerSetup.css";
import CustomerAddressForm from "./CustomerAddressForm";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import {
  useCreateItem,
  useSecureUpdateItem,
} from "../../_helper/actions/mutation/items";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";

const FORM_FIELDS = [
  { id: 1, label: "Institution name", type: "text", required: true },
  { id: 2, label: "Contact person name", type: "text", required: true },
  { id: 3, label: "Contact number", type: "number", required: true },
  { id: 4, label: "Email address", type: "email", required: true },
  { id: 5, label: "Status", type: "text", required: true },
  { id: 6, label: "Payment Terms", type: "dropdown", required: true },
];

const CustomerSetup = ({ mode, id }) => {
  const [formData, setFormData] = useState({
    status: "",
    institution_name: "",
    contact_person_name: "",
    contact_number: "",
    email_address: "",
    billing_address: {
      building_name: "",
      street_address: "",
      city: "",
      pincode: "",
    },
    communication_address: {
      building_name: "",
      street_address: "",
      city: "",
      pincode: "",
    },
    payment_terms: null,
  });
  const [searchParams] = useSearchParams();
  const groupId = searchParams.get("group_id");
  const optionId = searchParams.get("option_id");

  const [paymentTermOptions, setPaymentTermOption] = useState([]);
  const [clinic] = useAtom(clinicAtom);
  const navigate = useNavigate();

  const { data: paymentTerms } = useItemsFilter(
    ApiEndPoint.PAYMENT_TERMS,
    `?action=getPaymentTerms&backend=True&clinic_id=${clinic?.id}`,
    clinic?.id ? true : false
  );

  const { data: customerData } = useItemsFilter(
    ApiEndPoint.INSTITUTION_CUSTOMERS,
    `?action=getInstitutionCustomers&backend=True&clinic_id=${clinic?.id}&id=${id}`,
    clinic?.id && (mode === "edit" || mode === "view") ? true : false
  );

  useEffect(() => {
    if (customerData?.length > 0) {
      setFormData(customerData[0]);
    }
  }, [customerData]);

  useEffect(() => {
    if (paymentTerms) {
      const options = paymentTerms?.map((pterm) => ({
        key: pterm?.id,
        value: pterm?.id,
        text: pterm?.due_days === 0 ? "Immediate" : `${pterm?.due_days} Days`,
      }));
      setPaymentTermOption(options);
    }
  }, [paymentTerms]);

  const handleChange = (value, label) => {
    const exactLabel = label?.replace(/ /g, "_").toLowerCase();
    if(exactLabel === 'contact_number' && value?.length > 10){
     return;
    }
    if(exactLabel === 'institution_name'){
      value = value?.toUpperCase();
    }
    setFormData((prev) => ({ ...prev, [exactLabel]: value }));
  };

  const postMutation = useCreateItem(ApiEndPoint.INSTITUTION_CUSTOMERS);
  const updateMutation = useSecureUpdateItem(ApiEndPoint.INSTITUTION_CUSTOMERS);

  const handleSave = (e) => {
    e.preventDefault();
    let payload = {
      action: "postInstitutionCustomers",
      backend: "True",
      clinic_id: clinic?.id,
      ...formData,
    };

    if (mode === "edit" && id) {
      payload = {
        action: "patchInstitutionCustomers",
        backend: "True",
        clinic_id: clinic?.id,
        ...formData,
      };
      updateMutation.mutate(
        { id: id, data: payload },
        {
          onSuccess: () => handleCancel(),
          onError: () => toast.error("something went wrong"),
        }
      );
      return;
    }
    postMutation.mutate(payload, {
      onSuccess: () => handleCancel(),
      onError: () => toast.error("something went wrong"),
    });
  };

  const handleCancel = () => {
    navigate(`/new/setup?group_id=${groupId}&option_id=${optionId}`);
    // navigate(`/new/setup/customer%20master/3`);
  };

  const handleEdit = () => {
    navigate(
      `/new/setup/customersetup?active=customerdetails&mode=edit&id=${id}&group_id=${groupId}&option_id=${optionId}`
    );
  };

  return (
    <div className="cu-customer-setup-container">
      <form className="cu-customer-setup-form" onSubmit={handleSave}>
        <div className="cu-customer-setup-form-input-container">
          {FORM_FIELDS.map((field) => {
            if (field?.label === "Payment Terms") {
              return (
                <div key={field?.id} className="cu-customer-setup-form-input">
                  <label>{field?.label}</label>
                  <CuDropdown
                    options={paymentTermOptions}
                    disabled={mode === "view"}
                    value={
                      formData[field?.label?.replace(/ /g, "_").toLowerCase()]
                    }
                    onChange={(val) => handleChange(val, field?.label)}
                  />
                </div>
              );
            }
            return (
              <div key={field?.id} className="cu-customer-setup-form-input">
                <InputField
                  type={field?.type}
                  required={field?.required}
                  label={field?.label}
                  disabled={mode === "view"}
                  value={
                    formData[field?.label?.replace(/ /g, "_").toLowerCase()]
                  }
                  onChange={(e) => handleChange(e.target.value, field?.label)}
                />
              </div>
            );
          })}
        </div>

        <CustomerAddressForm
          setAddress={setFormData}
          billing_address={formData.billing_address}
          communication_address={formData.communication_address}
          isEdit={mode}
        />

        <div className="cu-customer-setup-form-btn-container">
          {mode !== "view" && (
            <button
              className={`cu-customer-setup-form-btn cu-customer-setup-form-save-btn`}
              type="submit"
            >
              {postMutation.isLoading ? <CuSpinner /> : "Save"}
            </button>
          )}

          {mode === "view" && (
            <button
              className={`cu-customer-setup-form-btn cu-customer-setup-form-save-btn`}
              //   type="submit"
              onClick={handleEdit}
            >
              Edit
            </button>
          )}

          <button
            className={`cu-customer-setup-form-btn cu-customer-setup-form-cancel-btn`}
            type="button"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </form>

      {/* {selectedOption?.value === "Invoice Details" && (
        <InvoiceDetails institutionId={isEdit?.data?.id} />
      )} */}
    </div>
  );
};

export default CustomerSetup;
